import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Button, Table } from '_zari/core'

import * as FormGroups from './formGroups'

const ConsumoDirectoModal = ({ handleClose, show, mainFormData, guardarConsumoDirectoFunction }) => {
  const __zariContext = React.useContext(ZariContext)

  // Pre-llenar centro de costo desde:
  //  1. _idCentroCostoNivel1 ya seteado en el detalle (si vino de OC con req)
  //  2. _idCentroCostoSugerido (centro de costo de la oficina solicitante traído por cons006)
  const [detalles, setDetalles] = React.useState(() =>
    (mainFormData.detalles || []).map(x => ({
      ...x,
      _idCentroCostoNivel1: x._idCentroCostoNivel1 || x._idCentroCostoSugerido || ''
    }))
  )

  const onChangeSelect = React.useCallback(
    (index, valKey, value) => {
      if (index === 0) {
        setDetalles(prev => {
          const nuevosDetalles = [...prev]
          return nuevosDetalles.map(x => ({
            ...x,
            [valKey]: value
          }))
        })
      } else {
        setDetalles(prev => {
          const nuevosDetalles = [...prev]
          nuevosDetalles[index][valKey] = value
          return nuevosDetalles
        })
      }
    },
    [setDetalles]
  )

  const handleSubmit = React.useCallback(() => {
    if (detalles.some(x => !x._idCentroCostoNivel1)) {
      __zariContext.snack('error', 'Todos los detalles deben tener centro de costo.')
      return
    }

    guardarConsumoDirectoFunction({
      ...mainFormData,
      detalles: detalles
    })
  }, [__zariContext, detalles, mainFormData, guardarConsumoDirectoFunction])

  return (
    <Modal size='lg' show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>CONSUMO DIRECTO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          filas={detalles}
          maxRowsShown={10}
          headRows={[
            {
              label: 'PRODUCTO'
            },
            {
              label: 'CANTIDAD'
            },
            {
              label: 'PRECIO'
            },
            {
              label: 'CENTRO COSTO'
            }
          ]}
          rowTemplate={(row, key) => (
            <Table.Row key={key}>
              <Table.Cell>{`${row.codigoProducto} - ${row.nombreProducto}`}</Table.Cell>
              <Table.Cell>{row.cantidad}</Table.Cell>
              <Table.Cell>{row.precio}</Table.Cell>
              <Table.Cell>
                <FormGroups.CentroCostoNivel1FormGroup
                  index={key}
                  centroCostoNivel1={detalles[key]._idCentroCostoNivel1 || ''}
                  setCentroCostoNivel1={val => onChangeSelect(key, '_idCentroCostoNivel1', val)}
                />
              </Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        <Button onClick={handleSubmit}>Continuar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ConsumoDirectoModal)
